import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=c9af4084&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9af4084')) {
      api.createRecord('c9af4084', component.options)
    } else {
      api.reload('c9af4084', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=c9af4084&", function () {
      api.rerender('c9af4084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/layout/Layout.vue"
export default component.exports